import React from 'react';

const TestimonialsSection: React.FC = () => {
  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-white px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            What Our Clients Say
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            Don't just take our word for it - hear from our satisfied customers
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {/* Testimonial 1 */}
          <div className="bg-gray-50 rounded-xl p-5 sm:p-6 lg:p-8 shadow-md hover:shadow-lg transition-shadow">
            <div className="flex items-center mb-3 sm:mb-4">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-[#83B328] text-base sm:text-lg"></i>
              ))}
            </div>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 italic">
              "J's Landscaping transformed our backyard into an absolute paradise! Their attention to detail and professionalism is unmatched. Highly recommend!"
            </p>
            <div className="flex items-center">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#83B328] rounded-full flex items-center justify-center mr-3 sm:mr-4">
                <span className="text-white font-bold text-sm sm:text-base">SM</span>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 text-sm sm:text-base">Sarah Mitchell</h4>
                <p className="text-xs sm:text-sm text-gray-600">Bel Air, MD</p>
              </div>
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className="bg-gray-50 rounded-xl p-5 sm:p-6 lg:p-8 shadow-md hover:shadow-lg transition-shadow">
            <div className="flex items-center mb-3 sm:mb-4">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-[#83B328] text-base sm:text-lg"></i>
              ))}
            </div>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 italic">
              "Reliable, affordable, and excellent quality work. They've been maintaining our property for 3 years now and we couldn't be happier with the results."
            </p>
            <div className="flex items-center">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#83B328] rounded-full flex items-center justify-center mr-3 sm:mr-4">
                <span className="text-white font-bold text-sm sm:text-base">JT</span>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 text-sm sm:text-base">James Thompson</h4>
                <p className="text-xs sm:text-sm text-gray-600">Fallston, MD</p>
              </div>
            </div>
          </div>

          {/* Testimonial 3 */}
          <div className="bg-gray-50 rounded-xl p-5 sm:p-6 lg:p-8 shadow-md hover:shadow-lg transition-shadow">
            <div className="flex items-center mb-3 sm:mb-4">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-[#83B328] text-base sm:text-lg"></i>
              ))}
            </div>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 italic">
              "From the initial consultation to the final result, everything was perfect. They truly care about their customers and it shows in their work."
            </p>
            <div className="flex items-center">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#83B328] rounded-full flex items-center justify-center mr-3 sm:mr-4">
                <span className="text-white font-bold text-sm sm:text-base">LR</span>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 text-sm sm:text-base">Lisa Rodriguez</h4>
                <p className="text-xs sm:text-sm text-gray-600">Abingdon, MD</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
